
const addToCart = (id, quantity) => {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/data/cart.json?event=add&id=' + id + '&quantity=' + quantity, true);
    xhr.onreadystatechange = function () {
        if (this.readyState != 4) return;
        let modalAddToCart = document.querySelector("[data-modal=add-to-cart]");
        if (modalAddToCart) {
            let dataJson = JSON.parse(this.responseText);
            if (dataJson.success != undefined) {
                modalAddToCart.querySelector('.name').innerHTML = dataJson.success.name;
                modalAddToCart.querySelector('.quantity').innerHTML = dataJson.success.quantity;
                modals.open(false, 'add-to-cart');
            }
            if (dataJson.total != undefined) {
                let headerCart = document.querySelector('.cart');
                if (headerCart) {
                    headerCart.querySelector('.counter span').innerHTML = dataJson.quantity;
                    headerCart.querySelector('.total span').innerHTML = dataJson.total;
                }
            }
        }
    }
    xhr.send();
}

export {addToCart}
